import React, { useState } from 'react'

import {
    Container,
    PokeItem,
    ItemCard,
    BallImg,
    ItemData,
    PokeImg,
    ItemDataRow,
    PotenciaDiv,
    PokeEmptyImage
} from "./styles"
import { Spin, Typography } from 'antd'
import { LoadingOutlined } from '@ant-design/icons';

const { Title } = Typography;
import pokeballImage from "../../../../Assets/pokeball.png"
import emptyPokeball from "../../../../Assets/pokeball-pixel.png"
import { ModalDetail } from './components/modalDetail';

const POKESPRITEURL = import.meta.env.VITE_POKESPRITES_URL;

export const MiEquipo = ({ data, cargandoData, refetch }) => {
    const [show, setShow] = useState(false);
    const [selected, setSelected] = useState([]);

    const showModal = (poke, index) => {
        setShow(true)
        setSelected({...poke, numero_equipo: index+1})
    }

    return (
        <div style={{ position: "relative"}}>
            <Container>
                {
                    !cargandoData ? (data 
                        ? data.map((item, index) =>  <PokeItem key={index} onClick={() => showModal(item, index)}><PokedexItem data={item} index={index}/></PokeItem>)
                        : <SinEquipos />) : <Spin indicator={<LoadingOutlined spin />} size="large" style={{marginTop: "10%"}}/>
                }
                {
                    show && <ModalDetail data={selected} setShow={setShow} refetch={refetch}/>
                }
            </Container>
                
        </div>
    )
}

const PokedexItem = ({data, index}) => {
    return (
        <ItemCard color={data.poke[0].colorCard ?? "rgb(190,192,190)"} capturado={"true"}>
          
          <BallImg src={pokeballImage}/>
  
          <ItemData>
            <Title style={{ color: "rgb(247, 247, 247)", fontFamily: "POKEFONT" }} level={3} >{data.nombre.toUpperCase()}</Title>
          </ItemData>
            <ItemDataRow>
                {
                    data.poke.map((item) => <PokeImg src={POKESPRITEURL+item.nombre.toLowerCase()+".png"} key={item.idPokemonCapturado}/>)
                }
            </ItemDataRow>
            <PotenciaDiv>
                <Title style={{ color: "rgb(247, 247, 247)", fontFamily: "POKEFONT" }} level={2} >{data.potenciaTotal}</Title>
                <Title level={2} style={{ color: "rgb(247, 247, 247)", fontFamily: "POKEFONT",marginTop: "-20px", fontSize: "11px" }}>{"POTENCIA"}</Title>

            </PotenciaDiv>
        </ItemCard>
    )
}

const SinEquipos = () => {

    return (
        <Container>
            <PokeEmptyImage src={emptyPokeball} />
            <Title style={{ fontFamily: "POKEFONT", transform: "translateY(-50px)" }} level={1}  >SIN EQUIPOS</Title>
            <Title level={5} style={{ fontFamily: "POKEFONT", marginTop: "-70px", fontSize: "11px" }}>Crea equipos en "Mis Cartas"</Title>
        </Container>

    )
}
